// Configurazione dichiarativa del modulo Anagrafiche.
// Ogni campo: { key, label, type?, source?, fill?, w? }
//   type: text | email | tel | date | textarea | autocomplete
//   source: comuni | province | marche | modelli | compagnie
//   fill: true  -> selezionando un comune auto-compila provincia+cap
//   w: 2        -> occupa due colonne

export const TITOLI = ["Dott.", "Avv.", "Ing.", "Geom.", "Dir.", "Sig.", "Sig.ra", "nessuno"];
const TITOLO_FIELD = { key: "titolo", label: "Titolo", type: "titolo" };
const SESSO_FIELD = { key: "sesso", label: "Sesso", type: "select", options: ["Maschio", "Femmina"] };

const CONTATTI = [
  { key: "indirizzo", label: "Indirizzo", w: 2 },
  { key: "numero_civico", label: "Numero Civico" },
  { key: "comune", label: "Comune", type: "autocomplete", source: "comuni", fill: true },
  { key: "provincia", label: "Provincia", type: "autocomplete", source: "province" },
  { key: "cap", label: "CAP" },
  { key: "telefono", label: "Telefono", type: "tel" },
  { key: "cellulare", label: "Cellulare", type: "tel" },
  { key: "email", label: "Email", type: "email" },
  { key: "pec", label: "PEC", type: "email" },
  { key: "note", label: "Note", type: "textarea", w: 2 },
];

const PERSONA = [
  TITOLO_FIELD,
  { key: "cognome", label: "Cognome" },
  { key: "nome", label: "Nome" },
  { key: "codice_fiscale", label: "Codice Fiscale" },
  ...CONTATTI,
];

const AZIENDA = [
  TITOLO_FIELD,
  { key: "denominazione", label: "Denominazione / Ragione sociale", w: 2 },
  { key: "partita_iva", label: "Partita IVA" },
  { key: "codice_fiscale", label: "Codice Fiscale" },
  { key: "referente", label: "Referente" },
  ...CONTATTI,
];

const COMPAGNIE_FIELD = { key: "compagnie", label: "Compagnie associate", type: "compagnie_multi", w: 2 };
const SDI_FIELD = { key: "codice_destinatario", label: "Codice SDI" };
const PERSONA_SDI = [...PERSONA.slice(0, 4), SDI_FIELD, ...PERSONA.slice(4)];
const PERSONA_PRO = [...PERSONA.slice(0, 3), SESSO_FIELD, ...PERSONA_SDI.slice(3), COMPAGNIE_FIELD];
const AZIENDA_PRO = [...AZIENDA, COMPAGNIE_FIELD];
const PERITO_PARTE_FIELD = { key: "perito_di_parte", label: "Perito di parte", type: "checkbox", hint: "Contrassegna come perito di parte", w: 2 };
const PERITI = [...PERSONA_PRO, PERITO_PARTE_FIELD];
const MEDICO_PARTE_FIELD = { key: "medico_legale_di_parte", label: "Medico legale di parte", type: "checkbox", hint: "Contrassegna come medico legale di parte", w: 2 };
const MEDICI_LEGALI = [...PERSONA_PRO, MEDICO_PARTE_FIELD];
const AVVOCATO_PARTE_FIELD = { key: "avvocato_di_parte", label: "Avvocato di parte", type: "checkbox", hint: "Contrassegna come avvocato di parte", w: 2 };
const AVVOCATI = [...PERSONA_SDI, AVVOCATO_PARTE_FIELD];

const COMPAGNIA = [
  TITOLO_FIELD,
  { key: "denominazione", label: "Nome / Ragione sociale", w: 2 },
  { key: "tipo_ufficio", label: "Tipo ufficio", type: "tipoufficio", w: 2 },
  { key: "codice_ivass", label: "Codice ANIA" },
  { key: "partita_iva", label: "Partita IVA" },
  { key: "codice_fiscale", label: "Codice Fiscale" },
  { key: "referente", label: "Referente" },
  { key: "indirizzo", label: "Indirizzo", w: 2 },
  { key: "numero_civico", label: "N° Civ." },
  { key: "comune", label: "Comune", type: "autocomplete", source: "comuni", fill: true },
  { key: "provincia", label: "Provincia", type: "autocomplete", source: "province" },
  { key: "cap", label: "CAP" },
  { key: "telefono", label: "Telefono", type: "tel" },
  { key: "fax", label: "Fax", type: "tel" },
  { key: "cellulare", label: "Cellulare", type: "tel" },
  { key: "email", label: "Email", type: "email" },
  { key: "pec", label: "PEC", type: "email" },
  { key: "sito_web", label: "Sito Web" },
  { key: "riguardo_a", label: "Riguardo a", w: 2 },
  { key: "note", label: "Note", type: "textarea", w: 2 },
];

const CARROZZIERE = [
  TITOLO_FIELD,
  { key: "denominazione", label: "Denominazione / Ragione sociale", w: 2 },
  { key: "partita_iva", label: "Partita IVA" },
  { key: "codice_fiscale", label: "Codice Fiscale" },
  { key: "codice_destinatario", label: "Codice SDI" },
  { key: "referente", label: "Referente / Titolare" },
  { key: "indirizzo", label: "Indirizzo (Via)", w: 2 },
  { key: "numero_civico", label: "N. Civico" },
  { key: "comune", label: "Comune", type: "autocomplete", source: "comuni", fill: true },
  { key: "provincia", label: "Provincia", type: "autocomplete", source: "province" },
  { key: "cap", label: "CAP" },
  { key: "telefono", label: "Telefono", type: "tel" },
  { key: "cellulare", label: "Cellulare", type: "tel" },
  { key: "email", label: "Email", type: "email" },
  { key: "pec", label: "PEC", type: "email" },
  { key: "iban", label: "IBAN", w: 2 },
  { key: "note", label: "Note", type: "textarea", w: 2 },
];
const CARROZZIERE_PRO = [...CARROZZIERE, COMPAGNIE_FIELD];

const CLIENTE = [
  TITOLO_FIELD,
  { key: "cognome", label: "Cognome" },
  { key: "nome", label: "Nome" },
  { key: "codice_fiscale", label: "Codice Fiscale" },
  { key: "data_nascita", label: "Data di nascita", type: "date" },
  { key: "luogo_nascita", label: "Luogo di nascita", type: "autocomplete", source: "comuni" },
  { key: "indirizzo", label: "Indirizzo (residenza)", w: 2 },
  { key: "comune", label: "Comune (residenza)", type: "autocomplete", source: "comuni", fill: true },
  { key: "provincia", label: "Provincia", type: "autocomplete", source: "province" },
  { key: "cap", label: "CAP" },
  { key: "telefono", label: "Telefono", type: "tel" },
  { key: "email", label: "Email", type: "email" },
];

export const VEICOLO_FIELDS = [
  { key: "targa", label: "Targa" },
  { key: "marca", label: "Marca", type: "autocomplete", source: "marche" },
  { key: "modello", label: "Modello", type: "autocomplete", source: "modelli" },
  { key: "colore", label: "Colore" },
  { key: "anno_immatricolazione", label: "Anno immatricolazione" },
  { key: "numero_polizza", label: "Numero polizza" },
  { key: "compagnia", label: "Compagnia assicurativa", type: "autocomplete", source: "compagnie" },
  { key: "scadenza_polizza", label: "Scadenza polizza", type: "date" },
  { key: "tipo_veicolo", label: "Tipo veicolo", type: "select", options: ["Autovettura", "Motociclo", "Ciclomotore", "Autocarro", "Altro"] },
];

// Scheda cliente organizzata in sezioni con intestazioni colorate.
const CLIENTE_SECTIONS = [
  {
    title: "DATI PERSONALI", color: "#1e3a8a", fields: [
      TITOLO_FIELD,
      { key: "cognome", label: "Cognome" },
      { key: "nome", label: "Nome" },
      { key: "codice_fiscale", label: "Codice Fiscale" },
      { key: "data_nascita", label: "Data di Nascita", type: "date" },
      { key: "sesso", label: "Sesso", type: "select", options: ["Maschio", "Femmina"] },
      { key: "luogo_nascita", label: "Luogo di Nascita", type: "autocomplete", source: "comuni", fillNascita: true },
      { key: "provincia_nascita", label: "Provincia di Nascita", type: "autocomplete", source: "province" },
      { key: "stato_nascita", label: "Stato di Nascita" },
    ],
  },
  {
    title: "CONTATTI E RESIDENZA", color: "#166534", fields: [
      { key: "indirizzo", label: "Indirizzo", w: 2 },
      { key: "numero_civico", label: "Numero Civico" },
      { key: "cap", label: "CAP" },
      { key: "comune", label: "Comune", type: "autocomplete", source: "comuni", fill: true },
      { key: "provincia", label: "Provincia", type: "autocomplete", source: "province" },
      { key: "telefono", label: "Telefono", type: "tel" },
      { key: "cellulare", label: "Cellulare", type: "tel" },
      { key: "email", label: "Email", type: "email" },
      { key: "pec", label: "PEC", type: "email" },
    ],
  },
  {
    title: "DATI BANCARI", color: "#7f1d1d", fields: [
      { key: "iban", label: "IBAN", w: 2 },
      { key: "intestatario_conto", label: "Intestatario conto" },
      { key: "banca", label: "Banca" },
      { key: "filiale", label: "Filiale" },
    ],
  },
  {
    title: "DOCUMENTI IDENTITÀ", color: "#374151", fields: [
      { key: "tipo_documento", label: "Tipo documento", type: "select", options: ["Carta d'identità", "Passaporto", "Patente"] },
      { key: "numero_documento", label: "Numero documento" },
      { key: "data_rilascio", label: "Data rilascio", type: "date" },
      { key: "data_scadenza_doc", label: "Data scadenza", type: "date" },
      { key: "ente_rilascio", label: "Ente rilascio" },
    ],
  },
  { title: "VEICOLI ASSOCIATI", color: "#9a3412", veicoli: true },
  {
    title: "NOTE", color: "#64748b", fields: [
      { key: "note", label: "Note", type: "textarea", w: 2 },
    ],
  },
];

const ISPETTORATI_FIELD = { key: "ispettorati", label: "Ispettorati di appartenenza", type: "ispettorati_multi", w: 2 };
const LIQUIDATORE = [...PERSONA_PRO, ISPETTORATI_FIELD];

const SEGNALATORE = [
  ...PERSONA.slice(0, 3), SESSO_FIELD,
  { key: "denominazione", label: "Ragione sociale (per aziende)", w: 2 },
  PERSONA[3], { key: "partita_iva", label: "Partita IVA" },
  ...PERSONA.slice(4),
  { key: "abbreviazione", label: "Abbrev. segnalatore (per stampa copertina)", w: 2 },
];

// atype -> configurazione
export const ANAG_TYPES = [
  { key: "clienti", label: "Clienti", icon: "UserRound", group: "Assistiti", fields: CLIENTE, veicoli: true, sections: CLIENTE_SECTIONS },
  { key: "controparti", label: "Controparti", icon: "Users", group: "Assistiti", fields: PERSONA },
  { key: "testimoni", label: "Testimoni", icon: "Eye", group: "Assistiti", fields: PERSONA },
  { key: "segnalatori", label: "Segnalatori", icon: "Megaphone", group: "Assistiti", fields: SEGNALATORE },
  { key: "mandanti", label: "Mandanti", icon: "Handshake", group: "Assistiti", fields: PERSONA },
  { key: "cessionari", label: "Cessionari", icon: "ArrowRightLeft", group: "Assistiti", fields: AZIENDA },

  { key: "avvocati", label: "Avvocati", icon: "Scale", group: "Professionisti", fields: AVVOCATI },
  { key: "avvocati_ctp", label: "Avvocati CTP", icon: "Scale", group: "Professionisti", fields: PERSONA_PRO },
  { key: "medici_legali", label: "Medici Legali", icon: "Stethoscope", group: "Professionisti", fields: MEDICI_LEGALI },
  { key: "periti", label: "Periti", icon: "Ruler", group: "Professionisti", fields: PERITI },
  { key: "accertatori", label: "Accertatori", icon: "Search", group: "Professionisti", fields: PERSONA_PRO },
  { key: "liquidatori", label: "Liquidatori", icon: "BadgeEuro", group: "Professionisti", fields: LIQUIDATORE },
  { key: "istruttori", label: "Istruttori", icon: "GraduationCap", group: "Professionisti", fields: PERSONA_SDI },
  { key: "commercialisti", label: "Commercialisti", icon: "Calculator", group: "Professionisti", fields: PERSONA_SDI },
  { key: "operatori", label: "Operatori", icon: "Headset", group: "Professionisti", fields: PERSONA_SDI },

  { key: "compagnie", label: "Compagnie assicurative", icon: "ShieldCheck", group: "Aziende ed Enti", fields: COMPAGNIA },
  { key: "agenzie", label: "Agenzie", icon: "Building", group: "Aziende ed Enti", fields: AZIENDA },
  { key: "carrozzieri", label: "Carrozzieri", icon: "Wrench", group: "Aziende ed Enti", fields: CARROZZIERE_PRO },
  { key: "istituti_mediazione", label: "Istituti di Mediazione", icon: "Landmark", group: "Aziende ed Enti", fields: AZIENDA },
  { key: "mediaconciliazione", label: "Mediaconciliazione", icon: "Handshake", group: "Aziende ed Enti", fields: AZIENDA },
];

export const SEDE_OPERATIVA_FIELDS = [
  { key: "op_indirizzo", label: "Indirizzo (Via)", w: 2 },
  { key: "op_numero_civico", label: "Numero Civico" },
  { key: "op_cap", label: "CAP" },
  { key: "op_comune", label: "Città", type: "autocomplete", source: "comuni", fillOp: true },
  { key: "op_provincia", label: "Provincia", type: "autocomplete", source: "province" },
];

export const ANAG_GROUPS = ["Assistiti", "Professionisti", "Aziende ed Enti"];

// Tipi anagrafica trattati come "professionisti": nominativo mostrato Cognome Nome.
export const PROF_TYPES = new Set([
  "avvocati", "avvocati_ctp", "medici_legali", "periti", "accertatori",
  "liquidatori", "istruttori", "commercialisti", "operatori", "carrozzieri",
]);

export function displayName(rec) {
  if (!rec) return "—";
  if (rec.denominazione) return rec.denominazione;
  const parts = PROF_TYPES.has(rec.type) ? [rec.cognome, rec.nome] : [rec.nome, rec.cognome];
  const full = parts.filter(Boolean).join(" ");
  return full || "—";
}

// Campi del contatto mostrabili sotto al nominativo nella scheda pratica (configurabili per contatto
// tramite la sezione "Campi visibili in pratica" della sua scheda anagrafica).
export const PRATICA_VISIBLE_FIELDS = [
  { key: "telefono", label: "Telefono" },
  { key: "cellulare", label: "Cellulare" },
  { key: "email", label: "E-mail" },
  { key: "pec", label: "PEC" },
  { key: "indirizzo", label: "Indirizzo" },
  { key: "tipo_ufficio", label: "Tipo ufficio" },
  { key: "codice_fiscale", label: "Codice Fiscale" },
  { key: "partita_iva", label: "Partita IVA" },
];
// Default applicato ai contatti che non hanno ancora una configurazione salvata (comportamento storico).
export const DEFAULT_PRATICA_FIELDS = ["telefono", "cellulare", "email", "pec"];
// Default per gli ispettorati/sedi (mostrano tipo ufficio e indirizzo).
export const DEFAULT_ISPETTORATO_FIELDS = ["tipo_ufficio", "telefono", "email", "indirizzo"];

export function composeIndirizzo(rec) {
  if (!rec) return "";
  const via = [rec.indirizzo, rec.numero_civico].filter(Boolean).join(", ");
  const loc = [rec.cap, rec.comune, rec.provincia ? `(${rec.provincia})` : ""].filter(Boolean).join(" ");
  return [via, loc].filter(Boolean).join(" — ");
}

// Costruisce le voci del riepilogo contatti da mostrare in pratica, nell'ordine configurato e
// scartando i campi vuoti.
export function praticaSummaryItems(rec, defaultKeys = DEFAULT_PRATICA_FIELDS) {
  if (!rec) return [];
  const keys = Array.isArray(rec.campi_pratica) ? rec.campi_pratica : defaultKeys;
  const val = (k) => (k === "indirizzo" ? composeIndirizzo(rec) : (rec[k] || "").toString().trim());
  return keys
    .map((k) => ({ key: k, label: (PRATICA_VISIBLE_FIELDS.find((f) => f.key === k) || {}).label || k, value: val(k) }))
    .filter((it) => it.value);
}
